import axiosInstance,{ endpoints } from 'src/utils/axios';

export async function getAllSignatureServiceOfCurrentUser(userID)
{
    return axiosInstance.get(`${endpoints.signature.getAll}/${userID}`);
}

export async function getSignatureByID(userID)
{
    return axiosInstance.get(`${endpoints.signature.getUnique}/${userID}`);
}

export async function createSignature(signature,userID)
{
    return axiosInstance.post(`${endpoints.signature.save}`,{...signature,userID});
}

export async function updateSignature(signature,userID)
{
    return axiosInstance.post(`${endpoints.signature.update}`,{...signature,userID});
}

export async function deleteSignature(signatureId)
{
    return axiosInstance.post(`${endpoints.signature.delete}`,{id:signatureId});
}
